// extracted by mini-css-extract-plugin
export default {"link":"n2nzE"};